import _defineProperty from "/var/log/nginx/source/CateringManagerX/CateringManager_Html/node_modules/_@babel_runtime-corejs2@7.13.7@@babel/runtime-corejs2/helpers/esm/defineProperty";

var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui"; // import pdf from "vue-pdf";

import { Loading } from "element-ui";
import { getPictureList } from "api/v1.common.picturelist.ts";
export default {
  name: "sourcePreview",
  // components: {
  //   pdf
  // },
  props: {
    data: {
      type: Object,
      default: ""
    }
  },
  data: function data() {
    return {
      Options: {
        inline: true,
        button: true,
        navbar: true,
        title: true,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: true,
        keyboard: true,
        dialogVisible: false,
        url: "data-source"
      },
      images: [],
      CoursewareType: "",
      courceSourceUrl: "",
      videoShow: false,
      isshowpdf: false,
      imageShow: false,
      dialogVisible: false,
      htmldialogVisible: false,
      audioVisible: false,
      pdfSourceShow: false,
      videoCurrentShow: false,
      audioCurrentShow: false,
      pdfCurrentShow: false,
      currentHtml: false,
      fullscreen: false,
      appendStatus: true,
      fullScreenShow: false,
      pptImageShow: false,
      scope: {
        image: []
      },
      newScope: {
        htmlPictrueList: []
      },
      pptImages: [],
      loadedRatio: 0,
      page: 1,
      numPages: 0,
      src: "",
      loading: false,
      htmlShowUrl: "http://114.55.179.40:80/xyd/g@A28CABD136D29427ED6AFC2344CDA134.ppt/html/html.html"
    };
  },
  watch: {
    data: function data(val) {
      var _this = this;

      var sourceUrl = val.url;
      var sourceType = val.docType;
      this.CoursewareType = sourceType;
      this.courceSourceUrl = sourceUrl; //图片

      if (sourceType == 1) {
        this.imageShow = true;
        this.images.push(this.courceSourceUrl);
        this.scope.image.push(this.courceSourceUrl);
      } //pdf,ppt


      if (sourceType == 2) {
        getPictureList(val.id).then(function (res) {
          if (!res.list) {
            _this.$message("稍等文件未转换完成！");
          } else {
            _this.pptImageShow = true;

            for (var _i = 0; _i < res.list.length; _i++) {
              _this.pptImages.push(res.list[_i].picpath);

              _this.newScope.htmlPictrueList.push(res.list[_i].picpath);
            }

            console.log(_this.pptImages.push(res.list[i].picpath));
          }
        });
      } //视频


      if (sourceType == 3) {
        this.videoCurrentShow = true;
        this.dialogVisible = true;
      } //音频


      if (sourceType == 4) {
        this.audioVisible = true;
        this.audioCurrentShow = true;
      } //html


      if (sourceType == 5) {
        getPictureList(val.id).then(function (res) {});
        this.htmldialogVisible = true;
        this.currentHtml = true;
      }
    },
    numPages: function numPages(val) {
      if (val > 0) {
        this.loading = false;
      } else {
        this.loading = true;
      }
    }
  },
  methods: (_methods = {
    closePptImageShow: function closePptImageShow() {
      this.pptImages = [];
      this.newScope.htmlPictrueList = [];
      this.pptImageShow = false;
    },
    closepdf: function closepdf() {
      this.isshowpdf = false;
    },
    pdferr: function pdferr(errurl) {
      console.log(errurl);
    },
    show: function show() {
      var viewer = this.$el.querySelector(".images").$viewer;
      viewer.show();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.videoCurrentShow = false;
      this.$refs.videoShow.pause();
    },
    inited: function inited(viewer) {
      this.$viewer = viewer;
    }
  }, _defineProperty(_methods, "show", function show() {
    this.$viewer.show();
  }), _defineProperty(_methods, "closeImageShow", function closeImageShow() {
    this.imageShow = false;
    this.images = [];
  }), _defineProperty(_methods, "closeAudio", function closeAudio() {
    this.audioVisible = false;
    this.audioCurrentShow = false;
    this.$refs.audioSourceDom.pause();
  }), _defineProperty(_methods, "prevPage", function prevPage() {
    //   this.page -= 1;
    //   console.log(this.page);
    //   console.log(this.numPages);
    if (this.page <= this.numPages) {
      this.page -= 1;
    }

    if (this.page <= 1) {
      this.page = 1;
    }
  }), _defineProperty(_methods, "nextPage", function nextPage() {
    this.page += 1;

    if (this.page >= this.numPages) {
      this.page = this.numPages;
    }
  }), _defineProperty(_methods, "closePdf", function closePdf() {
    this.page = 1;
    this.numPages = 0;
    this.pdfSourceShow = false;
    this.pdfCurrentShow = false;
  }), _defineProperty(_methods, "password", function password(updatePassword, reason) {
    updatePassword(prompt('password is "test"'));
  }), _defineProperty(_methods, "error", function error(err) {
    console.log(err);
  }), _defineProperty(_methods, "closeHtml", function closeHtml() {
    this.htmldialogVisible = false;
    this.currentHtml = false;
  }), _defineProperty(_methods, "pdfLaunchFullscreen", function pdfLaunchFullscreen() {
    var element = this.$refs.pdfFullScreen;

    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullScreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  }), _defineProperty(_methods, "htmlLaunchFullscreen", function htmlLaunchFullscreen() {
    var element = this.$refs.htmlIframeShow; //   element.style.width = "1200px";
    //   element.style.height = "800px";

    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  }), _methods)
};